import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IRpaConnectionBluePrism } from 'app/rpa-bots/core/IRpaBots';

@Component({
    selector: 'blue-prism-configuration',
    templateUrl: 'blue-prism-configuration.component.html',
    styleUrls: ['blue-prism-configuration.component.scss']
})
export class BluePrismConfigurationComponent implements OnInit {
    private _originalConnector: IRpaConnectionBluePrism;
    public URL_REGEXP = /^((((https?|ftps?):\/\/))(%[0-9A-Fa-f]{2}|[-()_.!~*';\/?:@&=+$,A-Za-z0-9])+)([).!';\/?:,][[:blank:]])?$/;
    @Output() testConnection = new EventEmitter<any>();
    @Output() save = new EventEmitter<any>();
    @Input()
    public get botDetail(): IRpaConnectionBluePrism {
        return this.botDetailData;
    }
    public set botDetail(value: IRpaConnectionBluePrism) {
        this._originalConnector = _.cloneDeep(value);
        this.botDetailData = value;
    }

    get hasChanges(): boolean {
        return !_.isEqual(this._originalConnector, this.botDetailData);
    }

    public botDetailData: IRpaConnectionBluePrism;

    @ViewChild('botConfigForm', { static: false}) botConfigForm: NgForm;

    constructor() { }

    ngOnInit() {
    }

    ngAfterViewChecked(): void {
        if (!this.botConfigForm.valid) {
            _.each(this.botConfigForm.controls, (ctrl) => {
                if (!ctrl.valid) {
                    ctrl.markAsTouched();
                }
            });
        }
    }

    isValid(): boolean {
        return !this.botConfigForm || this.botConfigForm.valid;
    }

    onTestConnection() {
        this.testConnection.emit();
    }

    onSave() {
        this.save.emit(this.botDetailData);
    }

    onClearAll() {
        this.botDetailData.displayName = '';
        this.botDetailData.baseUrl = '';
        this.botDetailData.password = '';
        this.botDetailData.userName = '';

        this.botConfigForm.reset();
    }
}
